<template>
  <div>
    <div class="max-w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <div class="mb-1 text-sm font-bold">{{ __("Name") }}</div>
            <div class="text-sm font-light">{{ template.name }}</div>
          </div>
          <div class="w-full pb-8 pr-6 lg:w-2/3">
            <div class="mb-1 text-sm font-bold">{{ __("Description") }}</div>
            <div class="text-sm font-light">{{ template.details }}</div>
          </div>
          <div class="w-full pb-8 pr-6">
            <div class="mb-1 text-sm font-bold">
              {{ __("Champs de fusion disponible") }}
            </div>
            <div class="text-sm font-light">
              <div class="gap-4 mb-1">
                {{ __("Nom") }} <span class="text-[#7366ff] cursor-pointer">{name}</span>
              </div>
              <div>
                {{ __("Identifiant unique") }}
                <span class="text-[#7366ff] cursor-pointer">{uid}</span>
              </div>
              <div>
                {{ __("Objet") }}
                <span class="text-[#7366ff] cursor-pointer">{subject}</span>
              </div>
              <div>
                {{ __("Nom de l'expéditeur") }}
                <span class="text-[#7366ff] cursor-pointer">{sender_name}</span>
              </div>
            </div>
          </div>

          <div class="w-full pb-8 pr-6">
            
            <div class="mb-1 text-sm font-bold">{{ __("Message E-mail") }}</div>
            <div
              class="editable-content"
              contenteditable="true"
              v-html="template.html"
              @input="onInput"
            ></div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button
            :loading="form.processing"
            class="ml-auto btn-indigo"
            type="submit"
            >{{ __("Update") }} {{ __("Template") }}</loading-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import { Link } from "@inertiajs/vue3";
import TextInput from "@/Shared/TextInput";
import LoadingButton from "@/Shared/LoadingButton";

import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadAdapter from "@/Shared/UploadAdapter";

export default {
  metaInfo() {
    return { title: this.form.name };
  },
  components: {
    LoadingButton,
    TextInput,
    Link,
    ckeditor: CKEditor.component,
  },
  layout: Layout,
  props: {
    template: Object,
  },
  remember: "form",
  data() {
    return {
      editorOptions: {
        debug: "info",
        modules: {},
      },
      comment: "",
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "|",
          "undo",
          "redo",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "outdent",
          "indent",
          "|",
          "insertTable",
          "blockQuote",
          "|",
          "imageUpload",
          "mediaEmbed",
          "|",
        ],
        table: {
          toolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        extraPlugins: [this.uploader],
      },
      form: this.$inertia.form({
        html: this.template.html,
      }),
    };
  },
  methods: {
    extractHead(content) {
      const match = this.template.html.match(/<head[^>]*>([\s\S]*?)<\/head>/i);
      return match ? match[1] : "";
    },
    extractBody(content) {
      const match = content.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
      return match ? match[1] : content;
    },
    onInput(e) {
      this.form.sms_text = e.target.innerHTML;
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new UploadAdapter(loader);
      };
    },
    onInput(e) {
      const content = e.target.innerHTML;

      // Réinjecter les balises manquantes si elles sont supprimées
      this.form.html = `
  <!DOCTYPE html>
  <html>
    <head>${this.extractHead(content)}</head>
    <body>${this.extractBody(content)}</body>
  </html>
`;
    },
    update() {
      this.form.put(this.route("templates.update", this.template.id));
    },
  },
};
</script>
